import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  appBar: {
    height: 64,
    margin: 0,
    padding: '0px 24px',
    '& .MuiPaper-elevation4': {
      boxShadow: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    [theme.breakpoints.up('xs')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  egreenLogoWrapper: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: 6,
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)',
    },
    '&:hover $egreenIso': {
      transform: 'rotate(-6deg) scale(1.1)',
    },
    '&:hover $egreenText': {
      color: '#aee9d1',
      background: 'rgba(6, 232, 159, 0.05)',
    },
  },

  egreenIso: {
    width: 33,
    height: 33,
    marginRight: 0.5,
    display: 'inline-block',
    position: 'relative',
    top: '-6px',
    transition: 'transform 0.4s ease-in-out',
  },

  egreenText: {
    fontSize: 25,
    fontWeight: 600,
    color: theme.palette.text.nonary,
    fontFamily: 'Montserrat',
    lineHeight: 1,
    letterSpacing: '0.9px',
    wordSpacing: '2px',
    transition: 'color 0.3s ease-in-out',
  },

  IconButton: {
    color: '#041370',
    margin: 2,
    padding: 0,
  },
  IconButtonLight: {
    color: '#fff',
    margin: 2,
    padding: 0,
  },

 IconButtonPersonIcon: {
    color: '#041370',
 marginLeft: -2,
     padding: 0,
  },
  IconButtonLightPersonIcon: {
    color: '#fff',
    marginLeft: -2,
    padding: 0,
  },


  tabsContainer: {
    marginLeft: 'auto',
  },
  selectedText: {
    textTransform: 'none',
    fontFamily: 'MontserratBold',
    fontWeight: '400',
    fontSize: '18px',
    color: theme.text,
  },
  text: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '22.4px',
    padding: 12,
    color: theme.palette.primary.nonary,
  },
  textGreen: {
    color: '#06E89F',
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '22.4px',
    padding: 16,
  },
  menuTextLang: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontWeight: '400',
    fontSize: '18px',
    color: theme.text,
  },
  link: {
    textDecoration: 'none',
    textDecorationLine: 'none',
    color: theme.background,
  },
  [theme.breakpoints.down('sm')]: {
    buttonESEN: {
      display: 'none',
    },
    buttonDarkMode: {
      display: 'none',
    },
    title: {
      width: 30,
    },
  },
  [theme.breakpoints.up('sm')]: {
    egreenLogo: {
      width: 200,
    },
  },
  active: {
    '& .MuiTypography-root': {
      fontFamily: 'Montserrat',
      fontSize: '18px',
      fontWeight: '600px',
      fontStyle: 'normal',
      lineHeight: '32px',
      color: '#333333',
    },
  },
  activeLight: {
    '& .MuiTypography-root': {
      fontFamily: 'Montserrat',
      fontSize: '18px',
      fontWeight: '600px',
      fontStyle: 'normal',
      lineHeight: '32px',
      color: theme.palette.text.secondary,
    },
  },
  activePersonIcon: {
    marginTop: 12,
    '& .MuiTypography-root': {
      fontFamily: 'Montserrat',
      fontSize: '18px',
      fontWeight: '600px',
      fontStyle: 'normal',
      lineHeight: '32px',
      color: '#333333',
    },
  },
  activePersonIconLight: {
    marginTop: 12,
    '& .MuiTypography-root': {
      fontFamily: 'Montserrat',
      fontSize: '18px',
      fontWeight: '600px',
      fontStyle: 'normal',
      lineHeight: '32px',
      color: theme.palette.text.secondary,
    },
  },

  flexItem: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '7px',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '6px',
    },
  },
  mainLinks: {
    width: 1024,
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
}));

export default useStyles;
